import { render } from "./FindSerial.vue?vue&type=template&id=145e0f68"
const script = {}
script.render = render

export default script